import {
  CasinoNotificationMaintenanceNotification,
  CasinoNotificationMaintenanceNotificationContent,
} from '@/schema';

const translateNotification = (
  notification: CasinoNotificationMaintenanceNotification,
  context: WorkerContext,
) => {
  const notificationContent =
    notification.content?.find(
      (content: CasinoNotificationMaintenanceNotificationContent) =>
        content.language === context.language,
    ) ??
    notification.content?.find(
      (content: CasinoNotificationMaintenanceNotificationContent) =>
        content.language === 'en',
    );

  if (!notificationContent) {
    return {
      ...notification,
    };
  }
  return {
    ...notification,
    title: notificationContent.title,
    body: notificationContent.text,
  };
};

export default translateNotification;
